import { motion } from "framer-motion";
import { SERVICE_GROUPS } from "../lib/content";
import CTA from "../components/sections/CTA";
import Marquee from "../components/sections/Marquee";
import { ArrowUpRight, Check } from "lucide-react";
import { Link } from "react-router-dom";

export default function Services() {
  return (
    <main data-testid="services-page">
      <section className="relative pt-40 md:pt-48 pb-24 md:pb-32">
        <div className="pointer-events-none absolute inset-0 -z-10">
          <div className="absolute -top-20 -left-20 w-[520px] h-[520px] rounded-full bg-[#0057ff] opacity-20 blur-[160px]" />
          <div className="absolute top-1/2 -right-20 w-[520px] h-[520px] rounded-full bg-[#6b11ff] opacity-15 blur-[160px]" />
        </div>

        <div className="mx-auto max-w-[1400px] px-6 md:px-10">
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="tag-glass"
            data-testid="services-overline"
          >
            <span className="dot" /> Capabilities · seven disciplines
          </motion.div>
          <motion.h1
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.05 }}
            className="font-display text-white mt-6 leading-[0.9] tracking-tight
                       text-[13vw] sm:text-[10vw] md:text-[6.5vw]"
            data-testid="services-heading"
          >
            Everything a brand <br />
            <span className="italic-accent text-grad-crimson">needs to be seen</span>.
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.15 }}
            className="mt-10 max-w-2xl text-white/70 text-lg md:text-xl leading-relaxed"
          >
            Every discipline that shapes a modern brand — owned media, digital
            performance, creative, production, technology — engineered as a
            single, compounding system.
          </motion.p>
        </div>
      </section>

      <Marquee />

      <section className="py-24 md:py-32" data-testid="services-list">
        <div className="mx-auto max-w-[1400px] px-6 md:px-10 space-y-24 md:space-y-32">
          {SERVICE_GROUPS.map((s, i) => (
            <motion.article
              key={s.key}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8 }}
              className={`grid grid-cols-12 gap-8 items-start ${i % 2 === 1 ? "md:pl-24" : ""}`}
              data-testid={`service-detail-${s.key}`}
            >
              <div className="col-span-12 md:col-span-4">
                <div className="tag-glass"><span className="dot" /> {s.tag}</div>
                <h2 className="font-display text-white text-3xl md:text-5xl leading-[1.02] tracking-tight mt-5">
                  {s.title}
                </h2>
              </div>
              <div className="col-span-12 md:col-span-4">
                <p className="text-white/70 text-lg leading-relaxed">{s.desc}</p>
                <Link
                  to="/contact"
                  className="mt-8 inline-flex items-center gap-2 text-white hover:text-[#ff5865] transition-colors"
                >
                  Discuss a brief <ArrowUpRight className="w-4 h-4" />
                </Link>
              </div>
              <div className="col-span-12 md:col-span-4">
                <ul className="space-y-3">
                  {s.items.map((it) => (
                    <li key={it} className="flex items-start gap-3 text-white/80 border-b border-white/5 pb-3">
                      <Check className="w-4 h-4 text-[#ff5865] mt-1 shrink-0" />
                      <span>{it}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </motion.article>
          ))}
        </div>
      </section>

      <CTA />
    </main>
  );
}
